// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__epq4e","log":"ModalInventoryLogs_log__3veBz","date":"ModalInventoryLogs_date__5CiKQ","userName":"ModalInventoryLogs_userName__mNvgR"};